import { rest } from "@/config";

const finalidades = ["aluguel", "venda"];

const Tipos = finalidades.reduce((acc, finalidade) => {
	acc[finalidade] = fetch(`${rest.endpoint}/${finalidade}/tipos.json?t=${Date.now()}`)
		.then(resp => resp.json())
		.then(
			({
				comercial = [],
				residencial = [],
				prontos = [],
				lancamentos = []
			}) => {
				return [
					...Object.values(comercial),
					...Object.values(residencial),
					...Object.values(prontos),
					...Object.values(lancamentos)
				];
			}
		)
		.then(rows =>
			rows.map(row => {
				row.finalidade = finalidade;
				return row;
			})
		);

	return acc;
}, {});

export const Aluguel = Tipos.aluguel;
export const Venda = Tipos.venda;

export const getAll = () =>
	Promise.all([Aluguel, Venda]).then(([aluguel, venda]) => ({
		aluguel,
		venda
	}));

export const getTipoById = async (finalidade, tipo_id) => {
	let tipos = await Tipos[finalidade.toLowerCase()];
	return tipos.find(({ id }) => id == tipo_id);
};

export default {
	Aluguel,
	Venda,
	getAll,
	getTipoById
};
